import { Component, OnInit } from '@angular/core';
import 'parse';
import { ToastService } from '../../service/toast.service';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-parameters-user',
  templateUrl: './parameters-user.component.html',
  styleUrls: ['./parameters-user.component.less']
})
export class ParametersUserComponent implements OnInit {
  timerEvent : NodeJS.Timer;
  firstName : string;
  lastName: string;
  constructor(private readonly _toastService : ToastService) { 
    this.firstName = parse.User.current().get('firstname');
    this.lastName = parse.User.current().get('lastname');
  }


  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen();
      console.log("values", this.firstName, this.lastName);
      parse.User.current().set('firstname',this.firstName)
      parse.User.current().set('lastname',this.lastName)
      parse.User.current().save().then((user) => {
          this._toastService.toastOpen(false);
      });
    }, 500);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-user/parameters-user.component.ts